/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import moment from "moment";
import { config } from "@/shared/utils/config";

/**
 * @returns seconds left before user can send another OTP
 */
export const secondsLeftToSendOtp = (time1, time2) => {
  const countdownTimer = config.countdownTimer;
  const duration = moment.duration(time1.diff(time2));

  /**
   * @returns difference between current date time from the last otp sent date time in seconds
   */
  const durationInSeconds = duration.asSeconds();

  // e.g. 60s - 15s = 45s left before user can send OTP
  return countdownTimer / 1000 - durationInSeconds;
};

/**
 * @returns milliseconds left before user can send another OTP
 */
export const millisecondsLeftToSendOtp = (time1, time2) => {
  const countdownTimer = config.countdownTimer;
  const duration = moment.duration(time1.diff(time2));

  /**
   * @returns difference between current date time from the last otp sent date time in milliseconds
   */
  const durationInMs = duration.asMilliseconds();

  // e.g. 60,000ms - 15,000ms = 45,000ms left before user can send OTP
  return countdownTimer - durationInMs;
};
